module.exports = __webpack_public_path__ + "assets/edit-c5c4e39f719769b381da1317fc275434.svg";